import { Box, Grid2 } from "@mui/material";

import { PageTitle } from "./components";

export const PageLayout = ({
  pageTitle,
  actions,
  children,
}: React.PropsWithChildren<{
  pageTitle: string | JSX.Element;
  actions?: React.ReactNode;
}>) => {
  return (
    <Grid2
      container
      direction={"column"}
      p={3}
      spacing={3}
      height={"100%"}
      flexWrap={"nowrap"}
    >
      <PageTitle pageTitle={pageTitle} actions={actions} />
      <Box sx={{ overflowY: "auto", scrollbarGutter: "stable", width: "100%" }}>
        {children}
      </Box>
    </Grid2>
  );
};
